// extracted by mini-css-extract-plugin
export default {"container":"ChaptersLayout_container__CT+Ym","body":"ChaptersLayout_body__9oLJW","main":"ChaptersLayout_main__tDjDr"};